import $ from 'domtastic';
import FeedData from './FeedData';

class Feed {
  static stopEvent(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  constructor(selectors) {
    this.selectors = selectors;
    if (!$(this.selectors.container)[0]) return;
    this.createDom();
  }

  createDom() {
    FeedData.get().then(this.append.bind(this));
  }

  append($pages) {
    const $container = $(this.selectors.container);
    const $mobileContainer = $(this.selectors.mobileContainer);

    $container.html('');
    $container.append($pages[0]);

    $mobileContainer.html('');
    $mobileContainer.append($pages[1]);

    $(this.selectors.flipRight).addClass('-enabled');

    this.cacheDom();
    this.bindEvents();
  }

  cacheDom() {
    this.$container = $(this.selectors.container);
    this.$mobileContainer = $(this.selectors.mobileContainer);
    this.$page = $(this.selectors.page);
    this.$flipRight = $(this.selectors.flipRight);
    this.$flipLeft = $(this.selectors.flipLeft);
  }

  bindEvents() {
    this.$flipRight.on('click', (event) => {
      Feed.stopEvent(event);
      this.flip(event.target, 'right');
    });

    this.$flipLeft.on('click', (event) => {
      Feed.stopEvent(event);
      this.flip(event.target, 'left');
    });
  }

  flip(button, direction) {
    const currentOffset = Number(this.$page.css('left').replace('%', ''));
    const currentPageIndex = (Math.abs(currentOffset) / 100) + 1;
    const nextIndex = (direction === 'left') ? currentPageIndex - 1 : currentPageIndex + 1;

    switch (nextIndex) {
      case 1:
        this.$flipLeft.removeClass('-enabled');
        break;
      case this.$page.length:
        this.$flipRight.removeClass('-enabled');
        break;

      default:
        this.$flipRight.addClass('-enabled');
        this.$flipLeft.addClass('-enabled');
        break;
    }

    const newOffset = (direction === 'left') ? currentOffset + 100 : currentOffset - 100;
    this.$page.css('left', `${newOffset}%`);
    this.cacheDom();
  }
}

export default Feed;



// WEBPACK FOOTER //
// ./components/Feed.js